import { connect } from 'react-redux';

import FirstTimeFavoriteModal from './FirstTimeFavoriteModal';

import {
  dontShow as dontShowActionCreator,
} from '../../../store/actions/favorites';

export function mapStateToProps(state) {
  const { favorites: { dontShow } } = state;
  return { dontShowAgain: dontShow };
}

export function mapDispatchToProps(dispatch) {
  return {
    dontShow(event) {
      dispatch(dontShowActionCreator(event.target.checked));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FirstTimeFavoriteModal);



// WEBPACK FOOTER //
// ./src/components/Favorites/FirstTimeFavoriteModal/FirstTimeFavoriteModalWrapper.js